//import React from "react";
//import { useNavigate } from "react-router-dom";
//import {
//    Card,
//    CardActionArea,
//    CardContent,
//    Typography,
//} from "@mui/material";
//import CreditCardIcon from "@mui/icons-material/CreditCard";
//import AutorenewIcon from "@mui/icons-material/Autorenew";
//import Navbar from "../components/Navbar";
//import "../App.css";
//import bg from "../assets/bg.svg";

//export default function Home() {
//    const navigate = useNavigate();

//    const cards = [
//        {
//            title: "Banka Taksit Bilgileri",
//            route: "/banka-taksit",
//            icon: <CreditCardIcon sx={{ fontSize: 65, color: "#CDE200" }} />,
//        },
//        {
//            title: "Değişim & İade Prosedürü",
//            route: "/degisim-iade",
//            icon: <AutorenewIcon sx={{ fontSize: 65, color: "#CDE200" }} />,
//        },
//        {
//            title: "KVKK",
//            route: "/kvkk",
//            icon: <AutorenewIcon sx={{ fontSize: 65, color: "#CDE200" }} />,
//        },
//    ];

//    return (
//        <div
//            className="home-container"
//            style={{
//                backgroundImage: `url(${bg})`,
//                backgroundSize: "cover",
//                backgroundPosition: "center",
//                backgroundRepeat: "no-repeat",
//                minHeight: "100vh",
//            }}
//        >
//            <Navbar />

//            <div
//                className="home-content"
//                style={{
//                    display: "flex",
//                    flexDirection: "column",
//                    alignItems: "center",
//                    gap: "30px",
//                    marginTop: "80px",
//                }}
//            >
//                {cards.map((card, i) => (
//                    <Card
//                        key={i}
//                        onClick={() => navigate(card.route)}
//                        sx={{
//                            width: 300,
//                            height: 170,
//                            borderRadius: "18px",
//                            background: "linear-gradient(180deg, #2C3944 0%, #1B2833 100%)",
//                            border: "5px solid rgba(255,255,255,0.9)", // ✅ 5px beyaz kenarlık
//                            boxShadow: "0 6px 16px rgba(0,0,0,0.3)",
//                            cursor: "pointer",
//                            transition: "all 0.3s ease",
//                            "&:hover": {
//                                transform: "translateY(-5px)",
//                                boxShadow: "0 12px 22px rgba(0,0,0,0.4)",
//                            },
//                        }}
//                    >
//                        <CardActionArea sx={{ height: "100%" }}>
//                            <CardContent
//                                sx={{
//                                    display: "flex",
//                                    flexDirection: "column",
//                                    alignItems: "center",
//                                    justifyContent: "center",
//                                    height: "100%",
//                                    color: "#fff",
//                                    textAlign: "center",
//                                }}
//                            >
//                                {card.icon}
//                                <Typography
//                                    variant="h6"
//                                    sx={{
//                                        color: "#fff",
//                                        fontWeight: 700,
//                                        marginTop: "10px",
//                                    }}
//                                >
//                                    {card.title}
//                                </Typography>
//                            </CardContent>
//                        </CardActionArea>
//                    </Card>
//                ))}
//            </div>
//        </div>
//    );
//}
import React from "react";
import { useNavigate } from "react-router-dom";
import {
    Card,
    CardActionArea,
    CardContent,
    Typography,
} from "@mui/material";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import PolicyIcon from "@mui/icons-material/Policy"; // KVKK ikonu için
import Navbar from "../components/Navbar";
import BusinessIcon from "@mui/icons-material/Business";
import "../App.css";
import bg from "../assets/bg.svg";

export default function Home() {
    const navigate = useNavigate();

    const cards = [
        {
            title: "Banka Taksit Bilgileri",
            route: "/banka-taksit",
            icon: <CreditCardIcon sx={{ fontSize: 65, color: "#CDE200" }} />,
        },
        {
            title: "Değişim & İade Prosedürü",
            route: "/degisim-iade",
            icon: <AutorenewIcon sx={{ fontSize: 65, color: "#CDE200" }} />,
        },
        {
            title: "KVKK",
            route: "/kvkk",
            icon: <PolicyIcon sx={{ fontSize: 65, color: "#CDE200" }} />, // 🟢 Güzel bir KVKK ikonu
        },
        {
            title: "Sportive Firma Bilgi Formu",
            route: "/firma-bilgi-formu",
            icon: <BusinessIcon sx={{ fontSize: 65, color: "#CDE200" }} />,
        },
    ];

    return (
        <div
            className="home-container"
            style={{
                backgroundImage: `url(${bg})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                minHeight: "100vh",
                display: "flex",
                flexDirection: "column",
            }}
        >
            <Navbar />

            {/* ✅ Kartları dikey ve yatay ortalayalım */}
            <div
                className="home-content"
                style={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center", // dikey ortalama
                    alignItems: "center", // yatay ortalama
                    gap: "35px",
                    paddingBottom: "60px",
                }}
            >
                {cards.map((card, i) => (
                    <Card
                        key={i}
                        onClick={() => navigate(card.route)}
                        sx={{
                            width: 300,
                            height: 170,
                            borderRadius: "18px",
                            background: "linear-gradient(180deg, #2C3944 0%, #1B2833 100%)",
                            border: "5px solid rgba(255,255,255,0.9)",
                            boxShadow: "0 6px 16px rgba(0,0,0,0.3)",
                            cursor: "pointer",
                            transition: "all 0.3s ease",
                            "&:hover": {
                                transform: "translateY(-5px)",
                                boxShadow: "0 12px 22px rgba(0,0,0,0.4)",
                            },
                        }}
                    >
                        <CardActionArea sx={{ height: "100%" }}>
                            <CardContent
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    height: "100%",
                                    color: "#fff",
                                    textAlign: "center",
                                }}
                            >
                                {card.icon}
                                <Typography
                                    variant="h6"
                                    sx={{
                                        color: "#fff",
                                        fontWeight: 700,
                                        marginTop: "10px",
                                    }}
                                >
                                    {card.title}
                                </Typography>
                            </CardContent>
                        </CardActionArea>
                    </Card>
                ))}
            </div>
        </div>
    );
}



